/** @format */

import React from "react";
import "./WeatherCard.css";
 

const WeatherCard = ({ title , value, unit, average, color }) => {
  return (
    <div className="weather-card" style={{ borderLeftColor: color }}>
      <div className="card-header">
        <h3 className="card-title">
          {title} ({unit})
        </h3>
      </div>
      <div className="card-content">
        <div className="main-value" style={{ color }}>
          {value}
          {unit}
        </div>
        {average && <div className="average-value">Avg: {average}</div>}
      </div>
    </div>
  );
};

export default WeatherCard;
